export const OPPORTUNITY_ACTIVITY_SCHEDULE_UNITS = ['minutes', 'hours', 'days'];

export const OPPORTUNITY_OWNER_STRATEGIES = [
  'conversation_assignee',
  'specific_user',
  'conversation_team_member',
  'pipeline_manager',
];

export const compositeActionParams = params => {
  if (Array.isArray(params)) return params[0] || {};
  return params || {};
};

const isBlank = value => value === undefined || value === null || value === '';

export const findPipeline = (pipelines = [], pipelineId) =>
  pipelines.find(pipeline => pipeline.id === pipelineId) || null;

export const isPipelineMember = (pipeline, userId) =>
  !!pipeline && (pipeline.user_ids || []).includes(userId);

export const opportunityActivityActionErrors = rawParams => {
  const params = compositeActionParams(rawParams);
  const errors = [];

  if (isBlank(params.activity_type)) errors.push('TYPE_REQUIRED');

  const amount = Number(params.scheduled_in);
  if (isBlank(params.scheduled_in) || !Number.isInteger(amount) || amount < 1) {
    errors.push('SCHEDULED_IN_REQUIRED');
  }
  if (!OPPORTUNITY_ACTIVITY_SCHEDULE_UNITS.includes(params.scheduled_unit)) {
    errors.push('SCHEDULED_UNIT_REQUIRED');
  }

  return errors;
};

export const createOpportunityActionErrors = (rawParams, pipelines = []) => {
  const params = compositeActionParams(rawParams);
  const errors = [];
  const pipeline = findPipeline(pipelines, params.pipeline_id);

  if (isBlank(params.pipeline_id)) errors.push('PIPELINE_REQUIRED');
  if (isBlank(params.pipeline_stage_id)) errors.push('STAGE_REQUIRED');
  if (!isBlank(params.value) && !(Number(params.value) >= 0)) {
    errors.push('VALUE_INVALID');
  }

  if (!OPPORTUNITY_OWNER_STRATEGIES.includes(params.owner_strategy)) {
    errors.push('OWNER_STRATEGY_REQUIRED');
  } else if (params.owner_strategy === 'specific_user') {
    if (isBlank(params.owner_id)) {
      errors.push('OWNER_REQUIRED');
    } else if (pipeline && !isPipelineMember(pipeline, params.owner_id)) {
      errors.push('OWNER_NOT_IN_PIPELINE');
    }
  } else if (
    params.owner_strategy === 'pipeline_manager' &&
    pipeline &&
    !isPipelineMember(pipeline, pipeline.manager_id)
  ) {
    errors.push('MANAGER_NOT_IN_PIPELINE');
  }

  return errors;
};
